import { render, staticRenderFns } from "./TheToolsViews.vue?vue&type=template&id=2ffa9fd6&"
import script from "./TheToolsViews.vue?vue&type=script&lang=js&"
export * from "./TheToolsViews.vue?vue&type=script&lang=js&"
import style0 from "./TheToolsViews.vue?vue&type=style&index=0&id=2ffa9fd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports